import { applyMiddleware, compose, createStore } from 'redux'
import thunk from 'redux-thunk'
import { createBrowserHistory } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'

import rootReducer from './reducers/rootReducer'

export const unininitializedState = {
  listInfo: {
    listId: '',
    title: '',
    description: '',
    viewType: '' // "DEFAULT" or "STUDENT"
  },
  todos: {},
  firestore: {
    isInitializing: false,
    listInfoIsLoaded: false,
    todoItemsAreLoaded: false,
    unlisteners: []
  }
}

export const history = createBrowserHistory()

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
export const store = createStore(
  connectRouter(history)(rootReducer),
  unininitializedState,
  composeEnhancers(applyMiddleware(thunk, routerMiddleware(history)))
)

export default store



// WEBPACK FOOTER //
// ./src/store.js